export default {
    BasedOnStateBudget: 'Căn cứ dự toán Ngân sách',
    BudgetAddition: 'Bổ sung cho ngân sách',
    BudgetExpenditure: 'Chi Ngân sách (Cấp)',
    AccountExpenditure: 'Tài khoản',
    BudgetFor: 'Cho Ngân sách (Cấp)',
    AccountFor: 'Tài khoản',
    ShowNote: 'Lên số liệu phần ghi chú',
    SwapFigure: 'Hoán vị số liệu',
    StateBankSection: 'Phần KBNN ghi',
    StateBankSectionTooltip: 'Phần kho bạc nhà nước ghi',
    DebitAccount: 'Nợ TK',
    DebitAccountTooltip: 'Nợ tài khoản',
    CreditAccount: 'Có TK',
    CreditAccountTooltip: 'Có tài khoản',
    FundCode: 'Mã quỹ',
    DBHCCode: 'Mã ĐBHC',
    DBHCCodeTooltip: 'Mã địa bàn hành chính',
    StateBankCode: 'Mã KBNN',
    StateBankCodeTooltip: 'Mã kho bạc nhà nước',
    NoteSection: 'Phần Ghi chú',
    BudgetExpenditureNote: 'Từ NS (Cấp)',
    BudgetExpenditureNoteTooltip: 'Từ ngân sách (Cấp)',
    BudgetForNote: 'Cho NS (Cấp)',
    BudgetForNoteTooltip: 'Cho ngân sách (Cấp)',
}